import { Pipe, PipeTransform } from '@angular/core';
import NP from 'number-precision'
import { notNullUndefined } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertSecToMin'
})
export class ConvertSecToMinPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    const a =  notNullUndefined(value)? Math.floor(NP.divide(value,60)).toString():'N/A'
    return a
  }

}
